import React from 'react';

import { FeeDetails } from '@ndvr/billing-api';

import { formatCurrency, formatDate, formatDateTime, titleCase } from 'utils';
import { AccountNameLink, DataGrid, HouseholdNameLink } from 'widgets';

interface CoreFeeDetailsProps {
    fee: FeeDetails;
    twoCol?: boolean;
    showDirectFeeAmounts?: boolean;
}
export const BasicFeeDetails = ({ fee, twoCol, showDirectFeeAmounts }: CoreFeeDetailsProps) => {
    const feeAmount = showDirectFeeAmounts ? fee.directFeeAmount : fee.totalFeeAmount;
    const settledFeeAmount = showDirectFeeAmounts ? fee.directSettledFeeAmount : fee.totalSettledFeeAmount;

    return (
        <DataGrid
            twoCol={twoCol}
            values={[
                {
                    label: 'Amount',
                    value: formatCurrency(feeAmount, fee.feeEntry.currency, 2),
                },
                {
                    label: 'Settled Amount',
                    value: formatCurrency(settledFeeAmount, fee.feeEntry.currency, 2),
                },
                {
                    label: 'Outstanding Amount',
                    value: formatCurrency(Number(feeAmount) - Number(settledFeeAmount), fee.feeEntry.currency, 2),
                },
                {
                    label: 'Fee Source',
                    value: titleCase(fee.feeSource),
                },
                {
                    label: 'Fee Type',
                    value: titleCase(fee.feeEntry.feeType),
                },
                {
                    label: 'Settlement Type',
                    value: titleCase(fee.feeEntry.settlementType),
                },
                {
                    label: 'Billing Date',
                    value: formatDate(fee.feeEntry.billingDate),
                },
                {
                    label: 'Date Created',
                    value: formatDateTime(fee.feeEntry.createdAt),
                },
                {
                    label: 'Settlement Household',
                    value: <HouseholdNameLink householdGUID={fee.feeEntry.settlementGlobalAccountGUID} />,
                },
                {
                    label: 'Generating Household',
                    value: <HouseholdNameLink householdGUID={fee.feeEntry.generatingGlobalAccountGUID} />,
                },
                {
                    label: 'Settlement Account',
                    value: fee.feeEntry.settlementPortfolioGUID && (
                        <AccountNameLink accountGUID={fee.feeEntry.settlementPortfolioGUID} />
                    ),
                },
                {
                    label: 'Generating Account',
                    value: fee.feeEntry.generatingPortfolioGUID && (
                        <AccountNameLink accountGUID={fee.feeEntry.generatingPortfolioGUID} />
                    ),
                },
            ]}
        ></DataGrid>
    );
};
